import { API_ENDPOINTS, API_HEADERS } from '../constants/api';
import { BannerPayload } from '../types';

export const fetchBanner = async (): Promise<BannerPayload | null> => {
  const response = await fetch(API_ENDPOINTS.banner, {
    headers: API_HEADERS,
  });

  if (!response.ok) {
    throw new Error(`Banner request failed with status ${response.status}`);
  }

  const data: BannerPayload[] = await response.json();
  return Array.isArray(data) && data.length > 0 ? data[0] : null;
};

